import { ApiHelper } from 'utils/apiHelper';

import { BoundCurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';

export const Autopayment = {
    setBalanceModel(model) {
        Autopayment.balanceModel = model;
    },

    async enable({ sum4payment, limit2life }) {
        // TODO: move to BalanceModel
        await ApiHelper.rpcCall({
            url: `/api/v1/projects/${BoundCurrentUserSelectors.getPid()}/billing/card/autopay`,
            method: 'POST',
            data: {
                sum4payment: Number(sum4payment).toFixed(2),
                limit2life: Number(limit2life).toFixed(2),
            },
        });

        Autopayment.balanceModel.set(
            {
                autopay: true,
                'extra.sum4payment': sum4payment,
                'extra.limit2life': limit2life,
            },
            {
                silent: true,
            },
        );
    },

    async disable() {
        // TODO: move to BalanceModel
        await ApiHelper.rpcCall({
            url: `/api/v1/projects/${BoundCurrentUserSelectors.getPid()}/billing/card/autopay`,
            method: 'DELETE',
        });

        Autopayment.balanceModel.set(
            {
                autopay: false,
            },
            {
                silent: true,
            },
        );
    },
};
